import { Decorators, TemplatedDialog, getjQuery } from "@serenity-is/corelib";

export class DroughtInfoDialog extends TemplatedDialog<any> {

    constructor() {
        super();

    }

    dialogOpen() {
        super.dialogOpen();
        let $ = getjQuery();

        $('.modal-header .btn-close').hide();
    }

    protected getDialogTitle(): string {
        return "Information";
    }
    protected getDialogOptions() {
        var opt = super.getDialogOptions();
        opt.buttons = [
            {
                text: "Ok",
                click: () => {
                    this.dialogClose();
                }
            }
        ];

        return opt;
    }

    public okClick: () => void;

    getTemplate() {
        return `
        <div style="margin:20px;">
            <img src="/content/site/images/watersource-full-logo-50.png" alt="Whealtley solutions logo" style="padding-bottom: 15px;">

            <p>
                The Wheatley Watersource Drought Map shows only current (live) drought restrictions,
                published and maintained by the participating UK organisations/water companies.
            </p>
            <p>
                Currently this site is a pilot and not all UK water companies publish their
                restrictions through Wheatley Watersource.
            </p>
        </div>
        `;
    }
}